import { Card as CardType, TruthTypes } from "../types";

interface TruthCard extends CardType {
  activity: TruthTypes | "other";
}

export const TRUTH_CARDS: TruthCard[] = [
  {
    genre: "truth",
    description: "Who in this room would you most like to kiss?",
    penaltyCost: 3,
    activity: "confession",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's your most embarrassing hookup story?",
    penaltyCost: 4,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "What's the most inappropriate place you've ever made out with someone?",
    penaltyCost: 3,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's your biggest turn-on in this room?",
    penaltyCost: 4,
    activity: "secret",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the most risqué text you've ever sent?",
    penaltyCost: 4,
    activity: "scandal",
    pub: true,
  },

  {
    genre: "truth",
    description: "What's your most embarrassing sexual experience?",
    penaltyCost: 5,
    activity: "memory",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the most inappropriate place you've ever had sex?",
    penaltyCost: 4,
    activity: "scandal",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's your biggest turn-off in this room?",
    penaltyCost: 3,
    activity: "confession",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the most risqué photo you've ever sent?",
    penaltyCost: 4,
    activity: "scandal",
    pub: true,
  },

  {
    description: "Tell the group your guilty porn pleasure.",
    penaltyCost: 2,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "Tell your bodycount to the group.",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },

  {
    description: "Share your last erotic dream.",
    penaltyCost: 2,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "Admit how many times you've watched porn in the last week.",
    penaltyCost: 1,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "Where is the weirdest place you've got horny?",
    penaltyCost: 2,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "Would you have a threesome?",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Have you ever blamed a fart on a pet?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Have you ever thought a cartoon character was hot?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Have you ever flexed into a mirror?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Would you go to a strip club?",
    penaltyCost: 1,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "Have you been to a strip club? Give a story.",
    penaltyCost: 2,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "Would you go to a sex club?",
    penaltyCost: 1,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "Have you been to a sex club? Give a story.",
    penaltyCost: 2,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },

  {
    description: "Reveal how long it takes you to orgasm.",
    penaltyCost: 1,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "Share the most illegal thing you've done.",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "Name the person you think is most likely to cheat.",
    penaltyCost: 2,
    genre: "truth",
    activity: "confession",
    pub: true,
  },

  {
    description:
      "Fuck, Marry, Kill. The person 3 to your left decides the selection.",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "What is the weirdest thing you've done while drunk?",
    penaltyCost: 2,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "Have you ever been caught wanking?",
    penaltyCost: 2,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description: "What is your relationship dealbreaker?",
    penaltyCost: 3,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Share a sexual fantasy.",
    penaltyCost: 2,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description: "Share an embarrassing sex story.",
    penaltyCost: 2,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description: "Have you done anything sexual with other people nearby?",
    penaltyCost: 2,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description:
      "Whats the biggest lie you have told to your partner/siblings/parents?",
    penaltyCost: 3,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "What's the worst betrayal of someone else you have done?",
    penaltyCost: 3,
    genre: "truth",
    activity: "memory",
    pub: true,
  },
  {
    description: "What's the kinkiest sexual fantasy that you havent done?",
    penaltyCost: 2,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description: "What's your favorite role play?",
    penaltyCost: 2,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "What's the weirdest role play you've ever done?",
    penaltyCost: 2,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "What's the most embarrassing thing that turns you on?",
    penaltyCost: 2,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description: "Have you ever faked it, when and why?",
    penaltyCost: 2,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "Who is the most embarrassing crush you have ever had?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "Describe the sex scenario that your least proud of.",
    penaltyCost: 2,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "Which celeb threesome would be your dream?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "How many sex toys do you own?",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Have you wanked at work?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Whats your favourite sex toy?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Have you filmed yourself having sex?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "What age did you start to wank?",
    penaltyCost: 1,
    genre: "truth",
    activity: "memory",
    pub: true,
  },
  {
    description: "Tell everyone about your first kiss.",
    penaltyCost: 1,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description: "Do you pee in the shower?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "What is the worst date you've ever been on?",
    penaltyCost: 1,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description: "Have you ever wanked in the shower/bath?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Where is the weirdest place you've wanked?",
    penaltyCost: 2,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Is there any sex toys that you don't have but want? If so, what?",
    penaltyCost: 2,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "What is the weirdest thing you've wanked too?",
    penaltyCost: 2,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "Have you recieved anal? If no, would you? ",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description:
      "What is the worse dirty talk you've said or sext you've sent?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description:
      "What's the most embarassing thing you've done to impress someone?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description:
      'Group decides 3 liquids for you to hypothetically "Crawl, Run, and Swim" through. How do you order them?',
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Have you tried your own cum? If yes, explain. If not, would you?",
    penaltyCost: 2,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "What is your go to sex song?",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: '"Fuck, Marry, Kill" the 3 people to the right. ',
    penaltyCost: 2,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Have you wanked about someone in the group? If so, who?",
    penaltyCost: 2,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "What's your favourite food to bring into the bedroom?",
    penaltyCost: 2,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Have you used a vibrating butt plug? If not, would you?",
    penaltyCost: 2,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "What's the worst thing you ever did to your sibling?",
    penaltyCost: 2,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description: "What's your worst sex related injury?",
    penaltyCost: 2,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description:
      "If you'd have been allowed to get a tattoo at 15 what would it be?",
    penaltyCost: 1,
    genre: "truth",
    activity: "memory",
    pub: true,
  },
  {
    description: "If you were in twilight which character would you be?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "Do you believe in ghosts?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "Do you believe in aliens?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description:
      "If you can hide a paperclip from trained detectives for 1 day you win £1m. How would you do it?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description:
      "If you got £1m per year but had an indestructible killer snail follow you for life. Would you take it?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "What is the weirdest conspiracy that you believe?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "What is your preference on pubes?",
    penaltyCost: 1,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "Where's the weirdest place you peed?",
    penaltyCost: 1,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description: "What are your thoughts on polyamory?",
    penaltyCost: 1,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description: "What's the drunkest you've ever been?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the most embarrassing thing you've ever done?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the most embarrassing thing you've done in a taxi?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "Have you taken any nudes/sexts while not at home?",
    penaltyCost: 1,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },

  {
    description: "Have you ever returned or re-gifted a present? If so, what?",
    penaltyCost: 1,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description: "Have you ever skinny dipped? Would you?",
    penaltyCost: 1,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description:
      "If you had to watch your parents/siblings fuck every night forever, would you join in once to stop it happening again?",
    penaltyCost: 3,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "What is your favourite sex toy?",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "When was the last time you wanked?",
    penaltyCost: 1,
    genre: "truth",
    activity: "secret",
    pub: true,
  },
  {
    description:
      "Your partner and your parent switch bodies.You can fuck one to return them to normal. Who do you pick?",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description:
      "If you and the person 5 to your right were to fuck. Who is top and who is bottom?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description:
      "If you and the person 5 to your left were to fuck. Who is top and who is bottom?",
    penaltyCost: 1,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description: "What age is your upper limit to sleep with?",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Do you prefer giving or receiving oral?",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description:
      "Whats the largest thing you've had inside you? Finger? Traffic cone?",
    penaltyCost: 1,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description:
      "What would you do if you were the opposite gender for a week? ",
    penaltyCost: 1,
    genre: "truth",
    activity: "memory",
    pub: true,
  },
  {
    description: "What is one item you hope nobody ever finds in your room?",
    penaltyCost: 1,
    genre: "truth",
    activity: "scandal",
    pub: true,
  },
  {
    description: "Tell the story of the drunkest you've ever been.",
    penaltyCost: 1,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description:
      "What's the most unusual thing you have in your wallet, purse, or pockets right now?",
    penaltyCost: 1,
    genre: "truth",
    activity: "memory",
    pub: true,
  },
  {
    description:
      "If you could only eat one food for the rest of your life, what would it be?",
    penaltyCost: 1,
    genre: "truth",
    activity: "memory",
    pub: true,
  },
  {
    description: "What is the most daring thing you've ever done on a dare?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    genre: "truth",
    description: "Admit a guilty pleasure no one knows about.",
    penaltyCost: 2,
    activity: "secret",
    pub: true,
  },
  {
    genre: "truth",
    description: "Reveal your most awkward hookup story.",
    penaltyCost: 2,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description: "Describe the weirdest fantasy you've ever had.",
    penaltyCost: 4,
    activity: "scandal",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the wildest place you've hooked up?",
    penaltyCost: 3,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description: "Share the most scandalous thing you've ever done in public.",
    penaltyCost: 5,
    activity: "scandal",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the worst hookup experience you've ever had?",
    penaltyCost: 3,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever fantasized about someone in this group? If so, who?",
    penaltyCost: 3,
    activity: "secret",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "What's the most embarrassing thing that's happened to you during sex?",
    penaltyCost: 5,
    activity: "sex",
    pub: true,
  },
  {
    genre: "truth",
    description: "Have you ever cheated or been cheated on? Share the story.",
    penaltyCost: 4,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "What's a secret you've never told anyone about your love or sex life?",
    penaltyCost: 5,
    activity: "secret",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the most inappropriate place you've ever hooked up?",
    penaltyCost: 3,
    activity: "slutty",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Who in this group do you think is the most adventurous in bed?",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever lied to get someone into bed? If so, what did you say?",
    penaltyCost: 5,
    activity: "memory",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever hooked up with a friend's ex or crush? Explain.",
    penaltyCost: 4,
    activity: "scandal",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "What's the pettiest reason you've ghosted someone or ended a relationship?",
    penaltyCost: 3,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever had a crush on someone who was completely off-limits?",
    penaltyCost: 4,
    activity: "confession",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever been caught in an awkward or compromising situation? What happened?",
    penaltyCost: 5,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the riskiest thing you've ever done for love or lust?",
    penaltyCost: 4,
    activity: "slutty",
    pub: true,
  },
  {
    genre: "truth",
    description: "Who was your worst hookup, and why?",
    penaltyCost: 4,
    activity: "slutty",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's something you've done while drunk that you regret?",
    penaltyCost: 3,
    activity: "drink",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever sent nudes to the wrong person? What did they say?",
    penaltyCost: 4,
    activity: "slutty",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the wildest party experience you've ever had?",
    penaltyCost: 3,
    activity: "drink",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Who in this group would you most likely have a one-night stand with?",
    penaltyCost: 5,
    activity: "slutty",
    pub: true,
  },
  {
    genre: "truth",
    description: "Have you ever had a fling or hookup that no one knows about?",
    penaltyCost: 4,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the worst date you've ever been on?",
    penaltyCost: 3,
    activity: "storytime",
    pub: true,
  },
  {
    genre: "truth",
    description: "Have you ever faked it in bed? If so, why?",
    penaltyCost: 4,
    activity: "scandal",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever had feelings for more than one person at the same time?",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Have you ever flirted with someone to get out of trouble? If so, what happened?",
    penaltyCost: 4,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the most scandalous thing you've done in public?",
    penaltyCost: 5,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's a fantasy you've never acted on but want to try?",
    penaltyCost: 5,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the biggest lie you've told to someone you liked?",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "Answer honestly: What's your most embarrassing moment?",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "What's the kinkiest thing you've ever done?",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description: "Have you ever faked it in bed? Explain.",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "truth",
    description:
      "Who in this group would you sleep with if there were no consequences?",
    penaltyCost: 4,
    activity: "other",
    pub: true,
  },
  {
    description: "Explain how you lost your virginity.",
    penaltyCost: 1,
    genre: "truth",
    activity: "other",
    pub: true,
  },
  {
    description: "Name 5 places you've had sex.",
    penaltyCost: 1,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Tell the group your weirdest kink.",
    penaltyCost: 3,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Tell the group the weirdest sexual thing you've done.",
    penaltyCost: 3,
    genre: "truth",
    activity: "sex",
    pub: true,
  },
  {
    description: "Name two people you'd have a threesome with.",
    penaltyCost: 3,
    genre: "truth",
    activity: "other",
    pub: true,
  },

  {
    description:
      "What's the worst thing you've ever done that you've never told anyone?",
    penaltyCost: 5,
    genre: "truth",
    activity: "confession",
    pub: true,
  },
  {
    description:
      "What's the most shameful thing you've done that your family doesn't know about?",
    penaltyCost: 3,
    genre: "truth",
    activity: "secret",
    pub: true,
  },

  {
    description: "What's the most embarrassing thing you've done while drunk?",
    penaltyCost: 2,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's your go-to drunk food order?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the worst drunk text you've ever sent?",
    penaltyCost: 2,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "Tell us about your worst hangover.",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the dumbest thing you've bought while drunk?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's your most embarrassing drunk dancing story?",
    penaltyCost: 2,
    genre: "truth",
    activity: "drink",
    pub: true,
  },

  {
    description: "What's the most regrettable hookup you've had while drunk?",
    penaltyCost: 5,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the most expensive thing you've broken while drunk?",
    penaltyCost: 5,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description:
      "What's the most embarrassing place you've thrown up from drinking?",
    penaltyCost: 5,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the worst decision you've ever made while drunk?",
    penaltyCost: 5,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the most illegal thing you've done while drunk?",
    penaltyCost: 5,
    genre: "truth",
    activity: "drink",
    pub: true,
  },

  {
    description: "What's the most embarrassing thing you've done in a taxi?",
    penaltyCost: 1,
    genre: "truth",
    activity: "drink",
    pub: true,
  },
  {
    description: "What's the most embarrassing thing that turns you on?",
    penaltyCost: 2,
    genre: "truth",
    activity: "slutty",
    pub: true,
  },
  {
    description: "What's the most scandalous thing you've done in public?",
    penaltyCost: 2,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
  {
    description:
      "What's the most embarrassing place you've thrown up from drinking?",
    penaltyCost: 5,
    genre: "truth",
    activity: "storytime",
    pub: true,
  },
];
